import { render, staticRenderFns } from "./loading.vue?vue&type=template&id=7e1fca1c&scoped=true&"
var script = {}
import style0 from "./loading.vue?vue&type=style&index=0&id=7e1fca1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e1fca1c",
  null
  
)

export default component.exports